import { observer } from "mobx-react-lite";
import { TCText } from "../../../components/tcText/TCText";
import { RadioButton } from "../../../components/radioButton/radioButton";
import { useNationalLeagueStore } from "../../../store/StoreContext";
import { LeagueLevel } from "../../../utils/typeValues";
import { Colors } from "../../../utils/colors";

export const LeagueLevelsRadioGroup: React.FC = observer(() => {
  const nationalLeagueStore = useNationalLeagueStore();
  return (
    <div>
      <TCText
        style={{
          fontWeight: 600,
          fontSize: 16,
          marginTop: 30,
          marginBottom: 20,
          color: Colors.darkBrown,
        }}
        value="Select league level"
      />
      <RadioButton
        selected={nationalLeagueStore.leagueLevel === LeagueLevel.Low}
        onChange={() => nationalLeagueStore.setLeagueLevel(LeagueLevel.Low)}
        label="Low"
      />
      <div style={{ height: 10 }} />
      <RadioButton
        selected={nationalLeagueStore.leagueLevel === LeagueLevel.Intermediate}
        onChange={() =>
          nationalLeagueStore.setLeagueLevel(LeagueLevel.Intermediate)
        }
        label="Intermediate"
      />
      <div style={{ height: 10 }} />
      <RadioButton
        selected={nationalLeagueStore.leagueLevel === LeagueLevel.High}
        onChange={() => nationalLeagueStore.setLeagueLevel(LeagueLevel.High)}
        label="High"
      />
    </div>
  );
});
